<template>
  <div class="wh100">
    <div class="form-center" v-loading="loading">
      <el-card
        v-for="item in tableData"
        :key="item.Id"
        class="box-card"
        body-style="padding: 10px;"
      >
        <div slot="header">
          <span
            ><span cliass="span">{{ item.DeviceItemName }}</span>
            <span cliass="span">（{{ item.DeviceItemCode }}）</span></span
          >
          <el-button
            style="float: right; padding: 3px 0"
            type="text"
            @click="openView(item)"
          >
            查看详情
          </el-button>
        </div>
        <div style="padding: 15px 0px">
          <div style="display: flex">
            <el-tooltip
              effect="dark"
              :content="`工单编号：${item.Code}`"
              placement="top"
              :open-delay="300"
            >
              <div class="item">
                <span cliass="span">工单编号：</span>
                <div class="p">{{ item.Code }}</div>
              </div>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              :content="`类型：${item.TypeName}`"
              placement="top"
              :open-delay="300"
            >
              <div class="item">
                <span cliass="span">类型：</span>
                <div class="p">{{ item.TypeName }}</div>
              </div>
            </el-tooltip>
          </div>

          <div style="display: flex; margin-top: 10px">
            <el-tooltip
              effect="dark"
              :content="`工单日期：${
                item.WorkOrderDate
                  ? moment(item.WorkOrderDate).format('YYYY-MM-DD')
                  : ''
              }`"
              placement="top"
              :open-delay="300"
            >
              <div class="item">
                <span cliass="span">工单日期：</span>
                <div class="p">
                  {{
                    item.WorkOrderDate
                      ? moment(item.WorkOrderDate).format('YYYY-MM-DD')
                      : ''
                  }}
                </div>
              </div>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              :content="`状态：${
                item.State === 0
                  ? '待提交'
                  : item.State === 1
                  ? '已提交'
                  : item.State === 2
                  ? '进行中'
                  : item.State === 3
                  ? '已完成'
                  : ''
              }`"
              placement="top"
              :open-delay="300"
            >
              <div class="item">
                <span cliass="span">状态：</span>
                <div class="p">
                  <el-tag v-if="item.State === 0">待提交</el-tag>
                  <el-tag type="success" v-if="item.State === 1">已提交</el-tag>
                  <el-tag type="warning" v-if="item.State === 2">进行中</el-tag>
                  <el-tag type="success" v-if="item.State === 3">已完成</el-tag>
                </div>
              </div>
            </el-tooltip>
          </div>
          <div style="display: flex; margin-top: 10px">
            <el-tooltip
              effect="dark"
              :content="`安装位置：${item.InstallationAreaName}`"
              placement="top"
              :open-delay="300"
            >
              <div class="item">
                <span cliass="span">安装位置：</span>
                <div class="p">
                  {{ item.InstallationAreaName }}
                </div>
              </div>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              :content="`供应商：${item.SupplierName}`"
              placement="top"
              :open-delay="300"
              v-if="item.SupplierName"
            >
              <div class="item">
                <span cliass="span">供应商：</span>
                <div class="p">
                  {{ item.SupplierName }}
                </div>
              </div>
            </el-tooltip>
          </div>
        </div>
      </el-card>
      <el-empty description="暂无数据" v-if="tableData.length == 0"></el-empty>
    </div>
    <div class="footer" v-loading="loading">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.PageIndex"
        :page-sizes="pagination.PageSizes"
        :page-size="pagination.PageRows"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  data() {
    return {
      moment,
      title: '',
      loading: false,
      tableData: [],
      searchData: {
        State: '',
        WorkOrderDate: [],
      },
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      row: {},
      drawer: false,
    }
  },
  props: {
    workOrderType: {
      type: String,
      default: '',
    },
    deviceItemId: {
      type: String,
      default: '',
    },
  },
  components: {},
  methods: {
    openView(item) {
      this.$emit('openView', item)
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    getDataList() {
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device_WorkOrder/GetWorkOrderDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: [
            {
              Condition: 'State',
              Keyword: this.searchData.State,
            },
            {
              Condition: 'WorkOrderDate',
              Keyword:
                this.searchData.WorkOrderDate?.length > 0
                  ? this.searchData.WorkOrderDate.join(',')
                  : '',
            },
            {
              Condition: 'WorkOrderType',
              Keyword: this.workOrderType || '',
            },
            {
              Condition: 'DeviceItemId',
              Keyword: this.deviceItemId,
            },
          ],
        })
        .then((resJson) => {
          this.loading = false
          if (!resJson.Success) {
            this.$notify.error(resJson.Msg)
            return
          }
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          // this.$nextTick(() => {
          //   this.$refs.dialogTable.clearSelection();
          // });
        })
    },
    openForm(title, row = {}) {
      this.tableData = []
      this.drawer = true
      this.row = row
      this.pagination.PageIndex = 1
      this.pagination.PageRows = 20

      this.getDataList()
      // this.getRoleList();

      this.title = title
    },

    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {
    if (this.deviceItemId) {
      this.getDataList()
    }
  },
  computed: {},
  watch: {
    workOrderType: {
      deep: true,
      immediate: true,
      handler(nValue) {
        if (this.deviceItemId) {
          this.getDataList()
        }
      },
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100% - 40px);
  overflow-y: auto;
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.item {
  font-size: 14px;
  display: flex;
  width: 50%;
  align-items: center;
  span {
    display: inline-block;
    width: 80px;
    text-align: right;
  }
  .p {
    flex: 1;
    display: inline-block;
    span {
      display: inline;
    }
  }
}
.box-card {
  margin-bottom: 10px;
}
::v-deep .form-center {
  .el-card {
    border-radius: 10px;
  }
}
</style>
